import SetupRmQhtcSmsModal from './setup-rm-qhtc-sms-modal.vue'
export default SetupRmQhtcSmsModal
